import React, { useState, useRef, useEffect } from "react";
import { Box, TextField } from "@mui/material";

const OtpInput = ({ length = 6, onChange }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus(); // Auto-focus on first input
    }
  }, []);

  const handleChange = (event, index) => {
    const value = event.target.value;
    if (!/^\d*$/.test(value)) return; // Only allow digits

    const newOtp = [...otp];

    // Allow only the first empty spot to be modified
    const firstEmptyIndex = newOtp.findIndex((d) => d === "");
    if (index > firstEmptyIndex) return;

    newOtp[index] = value;
    setOtp(newOtp);
    onChange(newOtp.join(""));

    // Move focus to next input if available
    if (value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace") {
      event.preventDefault(); // Prevent default behavior

      // Remove only the last filled digit
      const otpElement = otp.filter((d) => d !== "");
      const lastFilledIndex = otpElement?.length - 1;
      if (lastFilledIndex >= 0) {
        const newOtp = [...otp];
        newOtp[lastFilledIndex] = "";
        setOtp(newOtp);
        onChange(newOtp.join(""));

        // Move focus to the last filled input or first input if empty
        inputRefs.current[lastFilledIndex]?.focus();
      }
    }
  };
  
  return (
    <Box
      sx={{
        display: "flex",
        gap: { xs: 1, sm: 2 },
        justifyContent: "center",
        padding: 2,
      }}
    >
      {otp.map((data, index) => (
        <TextField
          key={index}
          type="tel"
          variant="outlined"
          autoFocus={index === 0}
          inputProps={{
            maxLength: 1,
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: {
              textAlign: "center",
              fontWeight: "500",
            },
          }}
          value={data}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          inputRef={(el) => (inputRefs.current[index] = el)}
          sx={{
            width: "45px",
            height: "45px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            "& .MuiOutlinedInput-input": {
              padding: "12px",
              fontSize: {
                xs: "16px",
                sm: "18px",
                md: "20px",
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default OtpInput;
